import React from 'react';

// import { SocialMedia } from '../socialMedia/SocialMedia';
// import { Nav } from '../nav/Nav';

import { Container } from 'shared/components/container/Container';
// import { CopyRight } from './copyRight/CopyRight';
import {
  Wrapper,
  FooterContainer,
  ContainerCopyRightsAndLinks,
  LinksWrapper,
  Link,
  LanguageSelect,
} from './ParticipantSelectionFooter.styles';
import { CopyRight } from 'shared/templates/main/footer/copyRight/CopyRight';
// import { SocialMedia } from 'shared/templates/main/socialMedia/SocialMedia';
import { Nav } from 'shared/templates/main/nav/Nav';

const defaultNav = <Nav link={Link} select={LanguageSelect} />;

export const ParticipantSelectionFooter = ({ children = defaultNav }) => {
  return (
    <Wrapper>
      <Container>
        <FooterContainer>
          <ContainerCopyRightsAndLinks>
            <CopyRight />
            <LinksWrapper>{children}</LinksWrapper>
          </ContainerCopyRightsAndLinks>
          {/* <SocialMediaContainer>
            <SocialMedia inverse />
          </SocialMediaContainer> */}
          {/* <StageClipLogo alt="StageClip" src={stageClipLogo} /> */}
        </FooterContainer>
      </Container>
    </Wrapper>
  );
};
